import { 
  SIGN_IN_ERROR,
  SIGN_IN_SUBMITTING,

  FORGOT_PASSWORD_SUBMITTING,
  FORGOT_PASSWORD_SUCCESS,

  RESET_PASSWORD_SUBMITTING, 
  RESET_PASSWORD_SUCCESS,

  CHANGE_PASSWORD_SUBMITTING,
  CHANGE_PASSWORD_SUCCESS,
  
  REQUEST_OTP_SUBMITTING,
  REQUEST_OTP_SUCCESS,
  SET_USER_INFO,
  SET_REMOVE_USER_INFO

} from 'Constants/actionConstants';
import { getUserInfo } from 'src/newSrc/utils/helpers';
import {  removeItemToLocal, setItemToLocal  } from "Utils/localStorage";
const authentication = (state={
  signin: {
    error: '',
    isSubmitting: false
  }, forgotPassword: {
    error: '',
    isSubmitting: false
  },
  resetPassword: {
    isLoading: false,
  },
  changePassword:{
    error: '',
    isLoading:false,
  },
  userInfo: getUserInfo() || null,
}, action)=> {
  let newState;
  if(action.type === SIGN_IN_ERROR) {
    newState = {...state};
    newState.signin = {
      error: action.error,
      isSubmitting: false
    }
  }
  else if(action.type === SIGN_IN_SUBMITTING) {
    newState = {...state};
    newState.signin = {
      error: '',
      isSubmitting: true
    }
  }
  else if(action.type === FORGOT_PASSWORD_SUCCESS) {
    newState = {...state};
    newState.forgotPassword = {
      isSubmitting: false
    }
  }
  else if(action.type === FORGOT_PASSWORD_SUBMITTING) {
    newState = {...state};
    newState.forgotPassword = {
      isSubmitting: true
    }
  }
  else if(action.type === RESET_PASSWORD_SUBMITTING) {
    newState = {...state};
    newState.resetPassword.isLoading = true;
  }
  else if (action.type === RESET_PASSWORD_SUCCESS) {
    newState = {...state};
    newState.resetPassword.isLoading = false;
  }
  else if(action.type===CHANGE_PASSWORD_SUBMITTING){
    newState = {...state};
    newState.changePassword={
      isLoading:true
    }
  }else if(action.type===CHANGE_PASSWORD_SUCCESS){
    newState = {...state};
    newState.changePassword.isLoading = false;
  }
  else if(action.type === REQUEST_OTP_SUBMITTING) {
    newState = {...state};
    newState.requestOTP.isLoading = true;
  }
  else if (action.type === REQUEST_OTP_SUCCESS) {
    newState = {...state};
    newState.requestOTP.isLoading = false;
  }
  else if (action.type === SET_USER_INFO) {
    newState = { ...state };
    setItemToLocal('tegUser', action.payload)
    newState.userInfo = action.payload;
  }
  else if (action.type === SET_REMOVE_USER_INFO) {
    newState = { ...state };
    removeItemToLocal('tegUser')
    newState.userInfo = null;
  }
  return newState || state;
}

export default authentication;
